import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_EXPORT, ENDPOINT_SEARCH, ENDPOINT_UTILISATEURS} from '@/constants/endpoints'
import { bytesToBase64 } from "../utils/stringUtil";

let store = {
  debug: true,
  state: {
    utilisateurs: []
  },
  get(id) {
    return axios
        .get(ENDPOINT_UTILISATEURS + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  create(utilisateur) {
    let encoded ='Basic ' + bytesToBase64(new TextEncoder().encode(JSON.stringify(utilisateur)));
    return axios
        .post(ENDPOINT_UTILISATEURS, {},{
          headers: { 'Authorization': encoded }
        })
        .then(() => {
          AlertStore.pushSuccess('Utilisateur créé avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  update(utilisateur) {
    let encoded ='Basic ' + bytesToBase64(new TextEncoder().encode(JSON.stringify(utilisateur)));
    return axios
        .put(ENDPOINT_UTILISATEURS, {},{
          headers: { 'Authorization': encoded }
        })
        .then(() => {
          AlertStore.pushSuccess('Utilisateur modifié avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  delete(id) {
    return axios
        .delete(ENDPOINT_UTILISATEURS + '/' + id)
        .then(() => {
          AlertStore.pushSuccess('Utilisateur supprimé avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  deleteAll(userIds) {
    return axios
        .delete(ENDPOINT_UTILISATEURS, {data: userIds})
        .then(() => {
          AlertStore.pushSuccess('Utilisateurs supprimés avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  search(utilisateur, pageIndex, pageSize, sortOptions) {
    let recherche = '';
    recherche+=JSON.stringify({key: 'username', operation: ':', value: utilisateur.username})+";";
    recherche+=JSON.stringify({key: 'nom', operation: ':', value: utilisateur.nom})+";";
    recherche+=JSON.stringify({key: 'prenom', operation: ':', value: utilisateur.prenom})+";";
    recherche+=JSON.stringify({key: 'email', operation: ':', value: utilisateur.email})+";";
    recherche+=JSON.stringify({key: 'roles', operation: '€', value: utilisateur.roles})+";";
    recherche+=JSON.stringify({key: 'marches', operation: '€', value: utilisateur.marche ? [utilisateur.marche] : null});
    
    let rechercheString = recherche+`&page=${pageIndex}&size=${pageSize}`;
    
    let url = ENDPOINT_UTILISATEURS + ENDPOINT_SEARCH;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        rechercheString += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }

    let encoded ='Basic ' + bytesToBase64(new TextEncoder().encode(rechercheString));

    return axios
        .post(url, {},{
          headers: { 'Authorization': encoded }
        })
  },
  export() {
    return axios.get(`${ENDPOINT_UTILISATEURS + ENDPOINT_EXPORT}`);
  }

};

export default store;
